<template>
    <div class="nav">
        <div class="nav-box flex-start-center clearfix">
            <a href="/"><img class="nav_logo" src="https://cdn.aigupiao.com/static/wrap/img/logo_4.png"></a>
            <div class="tabs">
                <a class="tabs_btn nav_inactive" href="/index?jump#tab0">首页</a>
                <a class="tabs_btn nav_inactive" href="/index?jump#tab1">社区</a>
                <a class="tabs_btn nav_inactive" href="/index?jump#tab2">专栏</a>               
                <a class="tabs_btn nav_inactive" :class=" this.$route.path =='/express/expresslist' ? 'nav_active' : ''" href="/express/expresslist">要闻</a>
            </div>
            <!--/index/index/rd/5140815.html /lives/index/rd/3579600.html /news/index/rd/2058715.html /express/index/rd/874719.html <a class="nav-word" target="_blank" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui"><label><li class="nav_inactive">下载APP</li> </label></a> -->
        </div>
        <div class="user_box">
            <div class="userUnlogin">
                <a v-if="userAvatar" :href="`/ucenter/index/`">
                    <span id="_logName"></span><img :src="userAvatar" alt="">
                </a>
                <a v-if="!userAvatar" href="/login/index/rd/980880418.html">
                    <span id="_logName"></span><img src="https://cdn.aigupiao.com/static/wrap/img/login_default_photo.png" alt="">
                </a>
            </div>
            <div class="userLogined" style="display:none;">
                <a href="/ucenter/index/"><span id="_logName"></span><img id="_logAvatar" src="#" alt=""></a>
            </div>
            <!--<div class="userUnlogin">未登录，请<a class="userLog_link" href="/login/index.html">登录</a>或<a class="userLog_link" href="/register/index.html">注册</a></div>-->
        </div>
        <!--<div class="personal-logo" style="border-bottom:0;background:none;width:3em;">
                <a class="nav-word" href="/ucenter/index/rd/660010170.html"><li class="nav_logos clearfix"> <img style="margin-left:30%;padding-top:0.8em;" src="https://cdn.aigupiao.com/static/wrap/img/gerenzhongxin.png"></img> </li></a>
            </div>-->
    </div>
</template>
<script>
export default {
    name: 'AppHeader',
    components: {},
    data() {
        return {
            randomStr: Math.random().toString(36).slice(-4)
        };
    },
    created() {
        this.getthisurl()
    },
    computed: {
        userAvatar() {
            return this.$store.state.user.avatarImgPath
        },
        userId() {
            return this.$store.state.user.userId
        }
    },
    methods: {
        getthisurl(){
            console.log(this.$route.path)
        }
        

    }

};
</script>
<style lang="css" scoped>
* {
    font-family: "PingFangSC-Regular", "PingFangSC-Light", "PingFang SC", sans-serif, "Microsoft YaHei";
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    margin: 0;
    padding: 0;
    list-style: none;
}

a {
    color: #333;
    text-decoration: none;
    /* 清除样式 ，每个网页都一样，基础文件*/
}

.nav {
    position: fixed;
    color: #1A1A1A;
    background-color: #fff;
    z-index: 999;
    top: 0;
    width: 100%;
    height: 48px;
    border-bottom: 1px solid #dfdfdf;
}

.nav-box {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    font-size: 0px;
}

.nav-box a {
    position: relative;
}

.nav-box a i {
    position: absolute;
    width: 30px;
    height: 2px;
    bottom: 0;
    left: 50%;
    margin-left: -24px;
    background: #fe484a;
    display: none;
}

.nav-box a.router-link-active {
    display: inline-block;
}

.nav-box a.router-link-active i {
    display: block;
}

.flex-start-center {
    -ms-flex-pack: flex-start;
    -webkit-box-pack: flex-start;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    -ms-flex-align: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.tabs {
    float: left;
}

.personal-logo {
    float: left;
    position: fixed;
    right: 0px;
    top: 0px;
}

.nav_logos img {
    float: left;
    width: 1.6em;
    padding-top: 1em;
    padding-bottom: 0.5em;
    margin-left: 80%;
}

.nav_logoss img {
    float: left;
    width: 1.6em;
    padding-right: 1.5em;
}

.nav_logo {
    float: left;
    margin: 11px 8% 11px 12px;
    width: auto;
    height: 26px;
}

.nav_inactive {    
    margin: 0 9px;
    font-size: 16px;
    line-height: 44px;
    color: #434343;
    margin-top: 2px;
    display: inline-block;
}

.router-link-active {
    color: #fe484a;
}

.user_box {
    position: fixed;
    top: 0;
    right: 0.8em;
    font-size: 14px;
    padding: 1.1em 0 2em 0;
}

.userLog_link {
    color: #fe484a;
}

.userLogined,
.userUnlogin {
    position: relative;
    padding-right: 2.6em;
}

.userLogined img,
.userUnlogin img {
    display: block;
    position: absolute;
    width: 2.2em;
    height: 2.2em;
    border-radius: 50%;
    right: 0;
    top: -0.55em;
}

#_logName {
    color: #767676;
}

#cnzz_stat_icon_1273269355 {
    display: none;
}

/*20190805修改详情页头部样式*/
.nav-box {
    width: 100%;
}
.nav_active{
    color: #fe484a;
    border-bottom: 2px solid  #fe484a;
}
</style>